
import { useEffect, useState, useRef} from "react";
//import { useEffect, useState } from "react";
import { clearRobot } from './Queries';
import Timer from "./Timer";
import logo from '../resources/extras/RUNNING_ROBOTS_TITLE.png';
import startScreenImg from '../resources/extras/robot_home__logo_nb.png';
import Login from "./Login";
import OutsideClickHandler from 'react-outside-click-handler';
import scoreBoard from '../resources/boxes/lazertag_scoreboard.png';
import robotGuy from '../resources/extras/robotGuy.png';
import BackToTop from './topButton/ScrollToTop'
import yellow_scoreBoard from '../resources/extras/glitch_yellow_scoreboard.png';
import blue_scoreBoard from '../resources/extras/glitch_blue_scoreboard.png';
import sweatyRobot from '../resources/extras/sweatrobot.png';
import TargetPractice from './TargetPracticePage/TargetPractice';


//import .css files
import '../components/start-screen/startScreen.css';
import '../components/lazerTagPage/lazerTagPage.css';
import '../components/topBubbles/bubbles.css';
import '../components/authPopUp/authPopUp.css';
import '../components/infoPage/infoPage.css';
import './rulesPage/rulesPage.css';
import '../components/manualScoreboard/manualScoreboard.css';
//end import .css files

// images
import haImage from '../resources/extras/images/ha.png';
import metalChas from '../resources/extras/images/Metal Chassis.jpg';
import pcb from '../resources/extras/images/PCB.png';
import vr from '../resources/extras/images/Screenshot_20240502-030601.png';
import turboPi from '../resources/extras/images/TurboPi.jpg';
import webApp1 from '../resources/extras/images/Webapp Home Page.png';
import webApp2 from '../resources/extras/images/Webapp Scoreboard.png';
//end image imports

interface KillFeedItem {
  attacker: string;
  defender: string;
  id: number;
}

const KillFeed = ({ feed }: { feed: KillFeedItem[] }) => {
  const [items, setItems] = useState<KillFeedItem[]>([]);
  const [removingId, setRemovingId] = useState<number | null>(null);

  useEffect(() => {
    // When new item(s) added
    if (feed.length > items.length) {
      const newItem = feed[feed.length - 1];

      // If we already have 2, start fade-out of the top one
      if (items.length >= 2) {
        const oldest = items[0];
        setRemovingId(oldest.id);

        // Wait for fade-out before removing
        setTimeout(() => {
          setItems((prev) => {
            const remaining = prev.filter((i) => i.id !== oldest.id);
            // Move remaining up and append new one at bottom
            return [...remaining, newItem];
          });
          setRemovingId(null);
        }, 600);
      } else {
        setItems((prev) => [...prev, newItem]);
      }
    }
  }, [feed, items]);

  return (
    <div className="kill-feed">
      {items.map((item, index) => (
        <div
          key={item.id}
          className={`kill-feed-item ${
            removingId === item.id ? "fade-out-up" : "slide-in"
          } position-${index}`}
        >
          <span className="attacker">{item.attacker}</span>
          <span> shot </span>
          <span className="defender">{item.defender}</span>
        </div>
      ))}
    </div>
  );
};



enum ComponentStates {
    StartScreen,
    UserCreationScreen,
    UserCreationScreen2,
    ResultsScreen,
    OptionsScreen,
    ControlsScreen,
    InfoButton,
    LazerTag,
    CaptureTheFlag,
    TargetPractice,
}

interface ScoreboardProps {
    setComponentState: (state: ComponentStates) => void;
}

function Scoreboard({ setComponentState }: ScoreboardProps) {
    const [yScore, setYScore] = useState(0);
    const [bScore, setBScore] = useState(0);
    

    return (
        <div className="scoreboard-container">
                <div className="blue-scoreboard">
                    <div className="score-buttons">
                        <button onClick={() => setBScore(bScore + 1)} className="b_plus-button"></button>
                        <button onClick={() => setBScore(Math.max(bScore - 1, 0))} className="b_minus-button"></button>
                    </div>
                    <div className="blue-robot-container">
                        <img src={blue_scoreBoard} alt="Blue Scoreboard Robot" className="blue_scoreboard_robot" />
                        <p className="b-score-text">Score: {bScore}</p>
                    </div>
                </div>
                <div className="yellow-scoreboard">
                    <div className="score-buttons">
                        <button onClick={() => setYScore(yScore + 1)} className="y_plus-button"></button>
                        <button onClick={() => setYScore(Math.max(yScore - 1, 0))} className="y_minus-button"></button>
                    </div>
                    <div className="yellow-robot-container">
                        <img src={yellow_scoreBoard} alt="Yellow Scoreboard Robot" className="yellow_scoreboard_robot" />
                        <p className="y-score-text">Score: {yScore}</p>
                    </div>
                </div>
                <button onClick={() => setComponentState(ComponentStates.StartScreen)} className="quit-button"></button>
        </div>
    );
}



const ImageScroll = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const images = [haImage,metalChas,pcb,vr,turboPi,webApp1,webApp2]; //Add Images Here
  
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 3000);
  
      return () => clearInterval(interval);
    }, [images.length]);
  
    const goBackward = () => {
      setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };
    const goForward = () => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };
  
    return (
        <div className="scroll-container">
          <img src={sweatyRobot} alt="Back" className="sweatRobot_format" />
          
          <div className="image-container">
            <img src={images[currentIndex]} alt="Slideshow" />
          </div>
      
          <button onClick={goBackward} className="backward-button"></button>
          <button onClick={goForward} className="forward-button"></button>
        </div>
      );
      
  };


let robotState: {robot_name: string, hits: number, shots: number, combat_id: number}[] = []

interface GameProps {
    componentState: ComponentStates;
    setComponentState: (state: ComponentStates) => void;
}
const Game = ({componentState, setComponentState }: GameProps): JSX.Element => {
    const [isChooseGameOpen, setIsChooseGameOpen] = useState(false);
    const [isRemovePlayerOpen, setIsRemovePlayerOpen] = useState(false);
    const [isAddPlayerOpen, setIsAddPlayerOpen] = useState(false);

    const toggleRemovePlayer = () => {
        setIsRemovePlayerOpen(!isRemovePlayerOpen);
    }

    const toggleAddPlayer = () => {
        setIsAddPlayerOpen(!isAddPlayerOpen);
    }

    const toggleChooseGame = () => {
        setIsChooseGameOpen(!isChooseGameOpen);
    }

    const [entryName, setEntryName] = useState('');
    const [_updatedEntryName, setUpdatedEntryName] = useState(entryName);
    const [robotList, _setRobotList] = useState(robotState);
    const [usableRobotList, _setUsableRobot] = useState(robotState);

    const [killFeed, setKillFeed] = useState<KillFeedItem[]>([]);
    const prevRobotListRef = useRef<{ robot_name: string; hits: number; shots: number }[]>([]);
/*
//fake effect for testing 
        useEffect(() => {
        const robotQueryInterval = setInterval(() => {
            // Fake robot data changing over time
            _setRobotList(prev => {
            const updated = prev.length
                ? prev.map(r => ({
                    ...r,
                    hits: r.robot_name === "BlackTank" ? r.hits + 1 : r.hits,
                    shots: r.robot_name === "BlackTank" ? r.shots + 1 : r.shots,
                }))
                : [
                    { robot_name: "GrayTank", hits: 0, shots: 0 },
                    { robot_name: "BlackTank", hits: 0, shots: 0 },
                ];
            return updated;
            });
        }, 2000);

        return () => clearInterval(robotQueryInterval);
        }, []);
*/
   useEffect(() => {
        const robotQueryInterval = setInterval(() => {
            const fetchRobotData = async () => {
                try {
                    const response = await fetch('http://runningrobots.unl.edu:8100/game/robots');
                    const data = await response.json();
                    const robots = data.message as { robot_name: string; hits: number; shots: number; combat_id: number }[];
                    _setRobotList((_) => robots);

                    const lookup = robots.reduce((acc, r) => {
                        acc[(r.robot_name)] = r;
                        return acc;
                    }, {} as Record<string, { robot_name: string; hits: number; shots: number; combat_id: number }>);
                    
                    _setUsableRobot(prev =>
                        prev
                            .filter(u => !!lookup[(u.robot_name)])
                            .map(u => {
                                const match = lookup[(u.robot_name)];
                                return {
                                    ...u,
                                    hits: match.hits ?? u.hits,
                                    shots: match.shots ?? u.shots,
                                    combat_id: match.combat_id ?? u.combat_id
                                };
                            })
                    );
                } catch (error) {
                    console.error('Failed to connect to BFCM:', error);
                }
            };
    
            fetchRobotData();
        }, 1500);
    
        return () => clearInterval(robotQueryInterval);
    }, []); 

    useEffect(() => {
  const prevList = prevRobotListRef.current;

  robotList.forEach((robot) => {
    const prev = prevList.find((r) => r.robot_name === robot.robot_name);

    // Trigger only when hits increase
    if (prev && robot.hits > prev.hits) {
      // Find defender (placeholder logic, ideally use real defender_id)
      const defender = robotList.find(r => r.robot_name !== robot.robot_name);

      if (defender) {
        setKillFeed((prevFeed) => [
            ...prevFeed,
            { attacker: robot.robot_name, defender: defender.robot_name, id: Date.now() },
        ]);
      }
    }
  });

  // Update stored list for next comparison
  prevRobotListRef.current = robotList;
}, [robotList]);
    
    const handleAddClick = () => {
        const name = entryName?.trim().toLowerCase();
        if (!name) return;
        clearRobots(name)
        let passed = false;
        let this_combat_id = 0;
        for (let i = 0; i < robotList.length; i++) {
            if (robotList[i]["robot_name"].trim().toLowerCase() === entryName.trim().toLowerCase()) {
                this_combat_id = robotList[i]["combat_id"]
            }
        }
        for (let i = 0; i < usableRobotList.length; i++) {
            if (usableRobotList[i]["robot_name"] === entryName) {
                passed = true
            }
        }
        if (passed === false) {
            _setRobotList((prevList) => [...prevList, { robot_name: entryName, hits: 0, shots: 0, combat_id: this_combat_id }]);
            _setUsableRobot((prevList) => [...prevList, { robot_name: entryName, hits: 0, shots: 0, combat_id: this_combat_id }]);
        }
    }

    const clearRobots = (targetname: string) => {
        for (let i = 0; i < robotList.length; i++) {
            if (robotList[i].robot_name.trim().toLowerCase() === targetname){
                clearRobot(robotList[i].combat_id as number);
            }
        }
    }

    const handleRemovalClick = () => {
        setUpdatedEntryName(entryName);
        //@ts-ignore
        console.log("Current: ", entryName)
        if (entryName !== null) {
            console.log("removed robot:", entryName)
            const name = entryName?.trim().toLowerCase();
            if (!name) return;
            // @ts-ignore
            for (let i = 0; i < robotList.length; i++) {
                console.log(robotList[i]["robot_name"])
                if (robotList[i]["robot_name"].trim().toLowerCase() === entryName.trim().toLowerCase()) {
                    _setUsableRobot((prevList) => prevList.filter(r => r.robot_name !== entryName));
                    console.log("list without removed robot:", usableRobotList)
                    clearRobots(entryName)
                }
            }
        }
        setEntryName("");
    };

    // @ts-ignore
    const handleSubmitForm = event => {
        event.preventDefault();
    }
    
    const [selectedGame, setSelectedGame] = useState("");

    const handleSelect = (gameMode: string) => {
        setSelectedGame(gameMode);
    };

    const handleNavigate = () => {
        if (selectedGame === "Lazer Tag") {
            setComponentState(ComponentStates.LazerTag) // Redirects to the selected game's webpage
        }
        else if (selectedGame === "Capture The Flag") {
            setComponentState(ComponentStates.CaptureTheFlag); // Redirects to the selected game's webpage
        }
        else if (selectedGame === "Target Practice") {
            setComponentState(ComponentStates.TargetPractice); // Redirects to the selected game's webpage
        }
    };

    switch (componentState) {
        default:
        case ComponentStates.StartScreen:
            return (
                <div>
                    <div className="start-screen">
                        <img src={logo} alt="logo" className='logo-text' id='logo-start-screen'></img>
                        <div className="start-screen-content">
                            <img src={startScreenImg} alt="pixel_robot" className="pixel_robot_right"></img>
                            <div className="start-screen-buttons">
                                <button onClick={toggleChooseGame} className='big-buttons'>Start Game</button>
                                <button onClick={() => setComponentState(ComponentStates.InfoButton)} className='big-buttons'>Info</button>
                            </div>
                            <img src={startScreenImg} alt="pixel_robot" className="pixel_robot_left"></img>
                        </div>
                        {isChooseGameOpen && <Login
                            content={
                                <>
                                    <button onClick={() => setComponentState(ComponentStates.StartScreen)} className="Auth-quit-button"></button>
                                        <OutsideClickHandler onOutsideClick={() => { setIsChooseGameOpen(false) }}>
                                        <form onSubmit={handleSubmitForm} className="Auth-form">
                                        <div className="Auth-form-content">
                                                <h4 className="Auth-form-title">Please Select Game Mode</h4>
                                                <div>
                                                <div className="dropdown" id="dropdown-alignement">
                                                    <div className="dropdown-content-alignment">
                                                    <button className="dropbtn">{selectedGame}</button>
                                                    <div className="dropdown-content">
                                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                                        <a href="#" onClick={() => handleSelect("Lazer Tag")}>Lazer Tag</a>
                                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                                        <a href="#" onClick={() => handleSelect("Capture The Flag")}>Capture The Flag</a>
                                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                                        <a href="#" onClick={() => handleSelect("Target Practice")}>Target Practice</a>
                                                    </div>
                                                    </div>
                                                    <button onClick={handleNavigate} className="select-btn">Select</button>
                                                </div>
                                            </div>
                                        </div>
                                        </form>
                                    </OutsideClickHandler>
                                </>
                            }
                        />}
                    </div>
                </div>
            );

        case ComponentStates.InfoButton:
            return (
                <div className="">
                    <div id="top"></div>
                    <div className="title-text">
                        <p></p>
                    </div>
                    {/* for some odd reason this section does not keep its stylizing across browsers */}
                    <div className="jump-to-section">
                    <p><b> Jump to:</b></p>
                    <ul>
                    <li><a href="#gameplay-mechanics">Gameplay Mechanics</a></li>
                    <li><a href="#equipment">Equipment</a></li>
                    <li><a href="#history">History of Running Robots</a></li>
                    <li><a href="#meet-the-teams">Meet The Teams</a></li>
                    <li><a href="#gallery">Gallery</a></li>
                    </ul>
                </div>
                    <div className="text-container" id="gameplay-mechanics">
                        <div className="text-titles">
                            <p>Gameplay Mechanics</p>
                        </div>
                        <div className="text-content">
                                <p>Put gameplay mechanics here...​</p>
                            </div>
                    </div>
                    <div className="text-container"id="equipment">
                        <div className="text-titles">
                            <p>Equipment</p>
                        </div>
                        <div className="text-content">
                                <p>Put Equpiment list here...</p>
                            </div>
                    </div>
                    <div className="text-container" id="history">
                        <div className="text-titles">
                            <p>History of Running Robots</p>
                        </div>
                        <div className="text-content">
                                <p>The Running Robots project has evolved over the past two years through multiple development phases and teams.​</p>
                                <p>The project was initially conceptualized and developed under the sponsorship of Marilyn Wolf, a professor at the University of Nebraska-Lincoln (UNL). The first iteration, RoboLaserTag, focused on integrating infrared (IR) sensor technology into modified RC cars, enabling them to engage in laser tag-style combat. The original team aimed to merge Laser Tag and Robot Combat into an interactive game where remote-controlled or semi-autonomous robots would "shoot" IR beams at targets on opposing robots. At the end of the year, the project featured: Basic IR sensor-equipped robots, A web-based scoring system, and Game mechanic instructions.​</p>
                                <p>The 2024-2025 team, under the sponsorship of Professor Dr. Bohn at UNL, took over the project with the goal of significantly expanding and refining it. The new team rebranded the effort as Running Robot Re-run, focusing on enhancing interactivity and immersion. Key advancements this team developed: Transitioning to a durable metal tank chassis for improved robustness, Restoring and improving TurboPi robot kits, integrating Raspberry Pi technology, Creating a custom PCB extension for more stable and permanent wiring solutions, Implementing camera movement controls to enhance user experience, Developing a mobile application for remote robot control, Implementing a VR view mode, allowing users to experience first-person robot control, Adding external controller support for a more immersive gameplay experience, Migrating the web application to Nuros, UNL’s hosting platform, And Preparing for mobile app deployment on the Google Play Store and Apple App Store.</p>
                            </div>
                    </div>
                    <div className="text-container" id="meet-the-teams">
                        <div className="text-titles">
                            <p>Meet The Teams!</p>
                        </div>
                        <div className="text-content">
                            <div className="blue-text">
                                <p>2022-2023 Running Robots Game Consists of:</p>
                            </div>
                                <p>Sponsor: Marilyn Wolf </p>
                                <p>Product Owner: Dr. Christopher Bohn </p>
                                <p>Tribe Lead: Jeff Falkinburg </p>
                                <p>Project Manager: William Browning </p>
                                <p>Coach: Stephen Slader </p>
                                <p>Technical Reviewer: Christian Lamppe </p>
                                <p>Squad Lead:Juan Guzman</p>
                                <p>Project Manager: Ryan Schumacher</p>
                                <p>Development Manager: Reed Lawrence</p>
                                <p></p>
                                <p>Developers:</p>
                                <p>David Ryande</p> 
                                <p>Monty McConnell</p>
                                <p>Connor Wilson</p>
                                <p>Thomas Vierk</p>
                                <p>Victoria Titsworth</p>
                                <p>Brian Belt</p>
                                <b></b>
                                <b></b>
                                <b></b>
                                <div className="blue-text">
                                    <p>2024-2025 Running Robots Game Consists of:</p>
                                </div>
                                <p>Sponsor: Dr. Chris Bohn </p>
                                <p>Tribe Lead: Jeffrey Falkinburg </p>
                                <p>Project Manager: Bill Browning </p>
                                <p>Coach: Jeffrey Nosanov </p>
                                <p> Squad Lead:  Wesley Hill </p>
                                <p>Product Manager: Nathan Srisa-an </p>
                                <p>Development Manager: Thadd Post </p>
                                <p> Developers:</p>
                                <p>Demetri Papageorge </p>
                                <p>Erin Hughey </p>
                                <p>Matt McCaslin </p>
                                <p>Teighan McGahan </p>
                                <p>Indigo Blood </p>
                                <p>Jake Erwin </p>
                                <p>Raoul Nya </p>
                                <p></p>
                            </div>
                    </div>

                    <div className="gallery-text">
                        <p></p>
                    </div>
                    <div className="" id="gallery">
                            <ImageScroll />
                        </div>

                    <BackToTop/>
                            
                </div>
            );
        case ComponentStates.LazerTag:
            return(
                <div>
                <div className="App">
                    <KillFeed feed={killFeed} />
                    <div className="lazer-content">
                    <Timer />
                        <div className="lazer-scoreboard-container">
                            <button onClick={() => setComponentState(ComponentStates.StartScreen)} className="quit-button-1"></button>
                            <img src={scoreBoard} alt="Scoreboard" className="scoreboard" />
                            <div className="player-list">
                            {usableRobotList.length > 0 ? (
                                usableRobotList.map((robot) => (
                                <div key={robot.robot_name} className="player-item">
                                    <img src={robotGuy} alt="Robot Icon" className="player-icon" />
                                    <p>{robot.robot_name}</p>
                                    <p>{robot.shots ?? 0}</p>  {/* If shots is null/undefined, show 0 */}
                                    <p>{robot.hits ?? 0}</p>
                                </div>
                                ))
                            ) : (
                                <p>No players added yet.</p>
                            )}
                            </div>
                            <div className="player-btns-container">
                                <button onClick={toggleAddPlayer} className="player-btns">Add</button>
                                <button onClick={toggleRemovePlayer} className="player-btns">Remove</button>
                            </div>
                        </div>
                        </div>
                            {isRemovePlayerOpen && <Login
                                content={
                                    <>
                                        <button onClick={() => setComponentState(ComponentStates.LazerTag)} className="Auth-quit-button"></button>
                                        <OutsideClickHandler onOutsideClick={() => { setIsRemovePlayerOpen(false) }}>
                                            <form onSubmit={handleSubmitForm} className="Auth-form">
                                                <div className="Auth-form-content">
                                                    <h4 className="Auth-form-title">Select Player to Remove</h4>
                                                    <div>
                                                    <div className="dropdown" id="dropdown-alignement">
                                                        <div className="dropdown-content-alignment">
                                                        <button className="dropbtn">{entryName}</button>
                                                        <div className="dropdown-content">
                                                            {usableRobotList.length > 0 ? (
                                                                usableRobotList.map((player, index) => (
                                                                    /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
                                                                    <a key={index} href="#" onClick={() => setEntryName(player.robot_name)}>
                                                                        {player.robot_name}
                                                                    </a>
                                                                ))
                                                            ) : (
                                                                    <p>No players available</p>
                                                            )}
                                                        </div>
                                                        </div>
                                                        <button onClick={handleRemovalClick} className="select-btn">Remove</button>
                                                    </div>
                                                </div>
                                            </div>
                                            </form>
                                        </OutsideClickHandler>
                                    </>
                                }
                                handleClose={toggleRemovePlayer}
                            />}
                            {isAddPlayerOpen && <Login
                                content={
                                    <>
                                        <button onClick={() => setComponentState(ComponentStates.LazerTag)} className="Auth-quit-button"></button>
                                        <OutsideClickHandler onOutsideClick={() => { setIsAddPlayerOpen(false) }}>
                                            <form onSubmit={handleSubmitForm} className="Auth-form">
                                                <div className="Auth-form-content">
                                                    <h4 className="Auth-form-title">Select Player to Add</h4>
                                                    <div>
                                                    <div className="dropdown" id="dropdown-alignement">
                                                        <div className="dropdown-content-alignment">
                                                        <button className="dropbtn">{entryName}</button>
                                                        <div className="dropdown-content">
                                                            {robotList.length > 0 ? (
                                                                robotList.map((player, index) => (
                                                                    /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
                                                                    <a key={index} href="#" onClick={() => setEntryName(player.robot_name)}>
                                                                        {player.robot_name}
                                                                    </a>
                                                                ))
                                                            ) : (
                                                                    <p>No players available</p>
                                                            )}
                                                        </div>
                                                        </div>
                                                        <button onClick={handleAddClick} className="select-btn">Add</button>
                                                    </div>
                                                </div>
                                            </div>
                                            </form>
                                        </OutsideClickHandler>
                                    </>
                                }
                                handleClose={toggleAddPlayer}
                            />}
                        </div>
                    </div>
                );
        case ComponentStates.CaptureTheFlag:
        return <Scoreboard setComponentState={setComponentState} />;
        case ComponentStates.TargetPractice:
            return <TargetPractice />;
       
    }
}

export default Game;

